import { render, staticRenderFns } from "./ComplianceGrid.vue?vue&type=template&id=65ee1712&scoped=true"
import script from "./ComplianceGrid.vue?vue&type=script&lang=js"
export * from "./ComplianceGrid.vue?vue&type=script&lang=js"
import style0 from "./ComplianceGrid.vue?vue&type=style&index=0&id=65ee1712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee1712",
  null
  
)

export default component.exports